import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { Ticket, TrendingUp, TrendingDown } from 'lucide-react';
import { useDashboardMetrics } from '@/hooks/queries/useDashboard';
import { WidgetSkeleton, WidgetError } from './WidgetSkeleton';
import { cn } from '@/lib/utils';

export function TicketsWidget() {
  const { data, isLoading, isError } = useDashboardMetrics();

  if (isLoading) return <WidgetSkeleton />;
  if (isError || !data) return <WidgetError message="Error al cargar métricas de tickets" />;

  const ticketsCerradosHoy = data.tickets.cerrados_hoy;
  const trend = ticketsCerradosHoy > 0 ? 'up' : 'neutral';

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          Tickets Abiertos
        </CardTitle>
        <div className="p-2 bg-blue-50 rounded-lg">
          <Ticket className="h-4 w-4 text-blue-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{data.tickets.abiertos}</div>
        <div className="flex items-center gap-1 mt-1">
          {trend === 'up' ? (
            <TrendingDown className="h-3 w-3 text-green-500" />
          ) : (
            <TrendingUp className="h-3 w-3 text-gray-400" />
          )}
          <p className={cn(
            'text-xs',
            trend === 'up' ? 'text-green-600' : 'text-gray-500'
          )}>
            {ticketsCerradosHoy} cerrados hoy
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
